module.exports = __webpack_public_path__ + "static/media/1007157.f605e377.jpg";